import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

import { adminUser, spaceAndCapitalize, renderErrors } from '../../utilities/Forms.js'
import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

const Audits = ({ klass, id, className }) => {
  const [audits, setAudits] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState("");
  const [unauthorized, setUnauthorized] = useState(false);

  const fetchAudits = async () => {
    setLoading(true)

    request("GET", `/v1/a/audits?class=${klass}&id=${id}`, "", () => {setUnauthorized(true)})
      .then(data => {
        setAudits(data)
        setLoaded(true)
        setLoading(false)
      })
      .catch(error => {
        reportErrorToHoneybadger(error)
        if (error instanceof Error) {
         setError(error)
        }
        else {
          setErrors(error.errors)
        }
      })
  };

  const renderOperation = (operation) => {
    switch(operation) {
      case "create":
        return <div className="inline-block action-status completed-action not-clickable">Created</div>
      case "update":
        return <div className="inline-block action-status awaiting-sign-off-action not-clickable">Updated</div>
      case "destroy":
        return <div className="inline-block action-status blocked-action not-clickable">Deleted</div>
      default:
        return null
    }
  }

  const renderEditor = (editor) => {
    if (editor !== null) {
      return (
        <>
          by {editor}
        </>
      )
    }
  }

  const renderSource = (system_source) => {
    if (system_source !== null) {
      return (
        <>
          from {system_source}
        </>
      )
    }
  }

  const renderChanges = (changes) => {
    if (changes === null) {
      return
    }

    return (
      <ul>
        {Object.keys(changes).map((name, index) => {
          const before = changes[name][0]
          const after = changes[name][1]

          return (
            <li key={index}>{spaceAndCapitalize(name)} changed from {spaceAndCapitalize(before)} to {spaceAndCapitalize(after)}</li>
          )
        })}
      </ul>
    )
  }

  className = className || "settings big-settings"

  // Only show Audits to Admins
  if (adminUser() === false) {
    return
  }

  if (unauthorized) {
    return <Redirect to="/login"/>
  }

  if (error) {
    return (
      <div className={className}>
        <div>{error.message}</div>
      </div>
    )
  }

  if (loading) {
    return (
      <div className={className}>
        <p>Loading ...</p>
      </div>
    )
  }

  if (loaded === false) {
    return (
      <div className={className}>
        <button className="button small centered" onClick={fetchAudits}>Show Audits</button>
      </div>
    )
  }

  if (loaded === true) {
    return (
      <div className={className}>
        <h3>Last 10 Audits</h3>
        {renderErrors(errors, 'audits')}
        {audits?.map((audit) => (
          <div className="audit-box" key={audit.id}>
            <div className="row">{audit.created_at}</div>
            <div className="row">{renderOperation(audit.operation)} {renderEditor(audit.editor_name)} {renderSource(audit.system_source)}</div>
            {renderChanges(audit.attribute_changes)}
            <div>{audit.custom_message}</div>
          </div>
        ))}
        {audits.length === 0 && <div>No Audits within the last three months.</div>}
      </div>
    )
  }
}

export default Audits;
